import type { ReactNode } from 'react'

import { FigureLabel, FigureValue } from '@/components/ui'
import { cn } from '@/utils'

export interface StatTileProps {
  label: string
  value: string
  sub?: ReactNode
  labelClassName?: string
  valueClassName?: string
  className?: string
  valueSize?: 'lg' | 'md' | 'sm'
}

const VALUE_SIZE_CLASSES = {
  sm: 'text-base',
  md: 'text-xl',
  lg: 'text-3xl',
}

export function StatTile({
  label,
  value,
  sub,
  labelClassName,
  valueClassName,
  className,
  valueSize = 'md',
}: StatTileProps) {
  return (
    <div className={cn('flex flex-col justify-between gap-1.5 p-4', className)}>
      <FigureLabel className={labelClassName}>{label}</FigureLabel>
      <FigureValue
        className={cn(
          'tracking-normal',
          VALUE_SIZE_CLASSES[valueSize],
          valueClassName,
        )}
      >
        {value}
      </FigureValue>
      {sub && (
        <div className="text-[11px] leading-snug text-muted-foreground">
          {sub}
        </div>
      )}
    </div>
  )
}
